// extracted by mini-css-extract-plugin
module.exports = {"action-buttons":"contract-views_action-buttons__1psht","back-info-message":"contract-views_back-info-message__24cdG"};